import React from 'react'
import FeatherIcon from 'feather-icons-react';
import {
} from 'utlis/AppMessages/AppMessages'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';

function ManageIntegrationTopBar(props) {
    return (
        <div id="manage-integration-topbar">
            <div className="d-flex manage-integration-topbar">
                <div className="rt_item st-form form-sm mb-0 me-2 nso-selectbox">
                    <select
                        className="form-control"
                        placeholder="Action"
                        id="parentCategoryName">
                        <option value="">NSO</option>
                        <option value="">NSO</option>
                        <option value="">NSO</option>
                    </select>
                </div>
                <div className="rt_item st-form form-sm mb-0 me-2 d-flex align-items-center all-integraions-selectbox">
                    <div className="me-2">showing</div>
                    <select
                        className="form-control"
                        placeholder="Action"
                        id="parentCategoryName">
                        <option value="">All Integrations</option>
                        <option value="">All Integrations</option>
                        <option value="">All Integrations</option>
                    </select>
                </div>
                <div className="rt_item st-form form-sm mb-0 me-2 d-flex align-items-center with-status-selectbox">
                    <span>with status</span>
                    <select
                        className="form-control ms-2"
                        placeholder="Action"
                        id="parentCategoryName">
                        <option value="">All</option>
                        <option value="">All</option>
                        <option value="">All</option>
                    </select>
                </div>

                <div className="rt_item st-form form-sm st-form-with-icon-right mb-0 me-2 search-selectbox">
                    <input type="text" className="form-control" placeholder="Search By Keywords" />
                    <div className="icon">
                        <FeatherIcon
                            icon="search"
                            size="16"
                            className="icon-main" />
                    </div>
                </div>
            </div>
            <div className="d-flex manage-integration-right-btn">
                <div className="rt_item st-form form-sm st-form-with-icon-left mb-0 me-2 filter-btn">
                    <button
                        type="button"
                        className="st-btn st-btn-sm st-btn-gray no-min-width d-flex align-items-center justify-content-center "
                        onClick={() => { }}
                    >
                        <FeatherIcon
                            icon="filter"
                            size="14"
                            className="icon me-1" />
                        <span>Filter</span>
                    </button>
                </div>
                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0">
                    <Link
                        to="/settings/integration"
                        className="st-btn st-btn-sm st-btn-primary no-min-width d-flex align-items-center justify-content-center "
                        onClick={() => { }}
                    >
                        <span>Add Integration</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

export default connect(getDataFromStore, null)(ManageIntegrationTopBar)